import React from "react";
import Routes from './routes/Index';

function App() {
    

    return (
        <Routes /> 
    );
  }
  
  export default App;